import { render } from "./EmailCustomization.vue?vue&type=template&id=0bd1768e&scoped=true&ts=true"
import script from "./EmailCustomization.vue?vue&type=script&lang=ts"
export * from "./EmailCustomization.vue?vue&type=script&lang=ts"

import "./EmailCustomization.vue?vue&type=style&index=0&id=0bd1768e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd1768e"]])

export default __exports__